export const CATEGORY_DESCRIPTION_MAX_LENGTH = 120;
